import { Injectable, Injector } from '@angular/core';
import { InterfaceBankTransfer } from '../entities/interface-bank-transfer';
import { BaseCrudService } from 'app/shared/_utils/services/base-crud-service';
import { HttpParams } from '@angular/common/http';
import { LazyLoadEvent } from 'primeng/primeng';
import { Observable } from 'rxjs';
import { ResponsePageable } from 'app/shared/_utils/services/responsePageable';
import { Vars } from '../model/vars';
import { tap } from 'rxjs/operators';

@Injectable()
export class InterfaceBankTransferService extends BaseCrudService<InterfaceBankTransfer> {
  public uri = '/api/interfaceBankTransfer/';

  constructor(injector: Injector) {
      super(injector);
     
    }

  buildSentence(entity?: InterfaceBankTransfer, event?: LazyLoadEvent): HttpParams {
    throw new Error('Method not implemented.');
  }

  searchInterfaceBankTransfer(   fiscalYear: any, executingUnit: any, month: any,
    employeeType: any, payrollType, fundingSourceId: any,  bankId: any,
    employee: any, type: any,
    object: Vars): Observable<ResponsePageable<InterfaceBankTransfer>> {
      const params = new HttpParams()
        .set('fiscalYearId', fiscalYear)
        .set('euId', executingUnit)
        .set('monthId', month)
        .set('employeeTypeId', employeeType)
        .set('payrollTypeId', payrollType)
        .set('fundingSourceId', fundingSourceId)
        .set('bankId', bankId)
        .set('employeeId', employee)
        .set('type', type)
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}searchBankTransfer`;
        return this.httpClient.post<ResponsePageable<InterfaceBankTransfer>>(url, object, {params}, )
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            return response;
          })
       );
    }

    fileGenerationBankTransfer(type: any): Observable<any> {
      const params = new HttpParams()
          .set('type', type)
      const url = `${this.rutaServidor}${this.uri}downloadFile`;
      this.spinnerService.showAll();
      return this.httpClient.post<InterfaceBankTransfer>(url, undefined, {params})
          .pipe(
            tap(response => {
              this.spinnerService.hideAll();
              // console.log(response)
              return response;
            })
         );
    }
}





// WEBPACK FOOTER //
// ./src/app/core/services/interface-bank-transfer.service.ts